import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enCommon from "../locales/en/common.json";
import ruCommon from "../locales/ru/common.json";

export const SUPPORTED_LANGUAGES = ["en", "ru"];
export const FALLBACK_LANGUAGE = "en";
export const DEFAULT_NAMESPACE = "common";

const resources = {
    en: {
        [DEFAULT_NAMESPACE]: enCommon,
    },
    ru: {
        [DEFAULT_NAMESPACE]: ruCommon,
    },
};

void i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: FALLBACK_LANGUAGE,
        fallbackLng: FALLBACK_LANGUAGE,
        interpolation: {
            escapeValue: false,
        },
        defaultNS: DEFAULT_NAMESPACE,
        ns: [DEFAULT_NAMESPACE],
        returnNull: false,
        react: {
            useSuspense: false,
        },
    });

export default i18n;
